import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IAccount } from '../../../core/store/digital-footprint/accounts/models/Accounts';
import {
  FilterProps,
  PagedResponse,
} from '../../../core/store/general/models/general';
import { createParams } from '../../../core/store/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getAccounts(props: FilterProps): Observable<PagedResponse<IAccount>> {
    return this.http.get<PagedResponse<IAccount>>(
      `${this.baseApiUrl}/digital-footprint/accounts${createParams(props)}`,
    );
  }
}
